module.exports = __webpack_public_path__ + "assets/d0e92b9e319a29703d673ca1255a541d.mp3";